import React from 'react';
import { Link } from 'react-router-dom';
import { SiWhatsapp } from 'react-icons/si';
import { MdEmail } from 'react-icons/md';
import { trackEvent } from "../utils/analytics";

function FloatingContact({ basePath = '' }) {
    return (
        <div className="floating-contact-container">
            <a
                href="https://wa.me/34696360968"
                target="_blank"
                rel="noopener noreferrer"
                className="floating-contact-whatsapp"
                onClick={() =>
                    trackEvent({
                        category: "Contact",
                        action: "click_whatsapp",
                        label: "Floating WhatsApp Button",
                    })
                }
            >
                <SiWhatsapp size={30} />
            </a>
            <Link to={`${basePath}/#contact`} className="floating-contact-email" onClick={() =>
                trackEvent({
                    category: "Contact",
                    action: "click_email_contact",
                    label: "Floating Email Button",
                })
            }>
                <MdEmail size={30} />
            </Link>
        </div>
    );
}

export default FloatingContact;
